import { Box } from "@hightouch/htui";
import type { ReactNode } from "react";

export const PHONE_FRAME_WIDTH = 280;
export const PHONE_FRAME_RADIUS = 38;

export function PhoneFrame({ children }: { children: ReactNode }) {
  return (
    <Box
      borderRadius={`${PHONE_FRAME_RADIUS}px`}
      border="8px solid black"
      boxShadow="0 4px 24px rgba(0,0,0,0.25)"
      width={`${PHONE_FRAME_WIDTH}px`}
      height="560px"
      position="relative"
      display="flex"
      flexDirection="column"
      overflow="hidden"
      flexShrink={0}
    >
      <Box
        flex={1}
        width="100%"
        bg="white"
        overflow="hidden"
        display="flex"
        flexDirection="column"
      >
        {children}
      </Box>
    </Box>
  );
}
